export default "__VITE_ASSET__fh1Q4PGF__";